import type { PortableTextBlock } from '@portabletext/types'

export enum Tab {
  All = 'All',
  BTS = 'BTS',
  Team = 'Team',
}

export enum Category {
  Event = 'Event',
  News = 'News',
  Tips = 'Tips',
  Safety = 'Safety',
  Wellbeing = 'Wellbeing',
  Team = 'Team',
}

export interface MessageCenterFilters {
  category?: Category
  onlyBts: boolean
  onlyUnread: boolean
}

export interface Message {
  messageId: string
  campaignId: string
  content: string
  category: Category
  createdAt: string
  teamName?: string | null
  readAt?: string | null
  isLiked: boolean
  likesCount: number
}

interface Asset {
  asset: {
    url: string
    dimensions: {
      height: number
      width: number
    }
  }
}

export enum SanityLinkType {
  Internal = 'internal',
  External = 'external',
  Event = 'event',
  Survey = 'survey',
  Social = 'social',
}

export interface SanityLinkBase {
  type: SanityLinkType
  label: string
}

export interface SanityExternalLink extends SanityLinkBase {
  type: SanityLinkType.External
  url: string
}

export interface SanityInternalLink extends SanityLinkBase {
  type: SanityLinkType.Internal
  path: string
}

export interface SanityEventLink extends SanityLinkBase {
  type: SanityLinkType.Event
  event: { _ref: string; eventSlug: string }
}

export interface SanitySurveyLink extends SanityLinkBase {
  type: SanityLinkType.Survey
  survey: 'tellUsAboutYou' | 'closing'
}

export interface SanitySocialLink extends SanityLinkBase {
  type: SanityLinkType.Social
  social: 'facebook' | 'x'
}

export type SanityLink =
  | SanityExternalLink
  | SanityInternalLink
  | SanityEventLink
  | SanitySurveyLink
  | SanitySocialLink

export interface SanityMessage {
  title: string
  subtitle?: string
  category: {
    name: string
    playerCategory: Category
    icon: Asset
    image: Asset
  }
  body: PortableTextBlock[]
  link1?: SanityLink
  link2?: SanityLink
  image?: Asset
  imagePosition: 'before' | 'after'
}

export interface TeamMessage extends Message {
  category: Category.Team
  title: string
  body: string
}

export interface MessageWithContent extends Message {
  sanity: SanityMessage
}
